/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { NumericTrackItDataTypeDto } from './NumericTrackItDataTypeDto';
import {
    instanceOfNumericTrackItDataTypeDto,
    NumericTrackItDataTypeDtoFromJSON,
    NumericTrackItDataTypeDtoFromJSONTyped,
    NumericTrackItDataTypeDtoToJSON,
} from './NumericTrackItDataTypeDto';

/**
 * @type NumericTrackItDataTypeFilterDtoDataType
 * 
 * @export
 */
export type NumericTrackItDataTypeFilterDtoDataType = NumericTrackItDataTypeDto;


export function NumericTrackItDataTypeFilterDtoDataTypeFromJSON(json: any): NumericTrackItDataTypeFilterDtoDataType {
    return NumericTrackItDataTypeFilterDtoDataTypeFromJSONTyped(json, false);
}

export function NumericTrackItDataTypeFilterDtoDataTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumericTrackItDataTypeFilterDtoDataType {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...NumericTrackItDataTypeDtoFromJSONTyped(json, true) };
    return  NumericTrackItDataTypeDtoFromJSONTyped(json, true);
}

export function NumericTrackItDataTypeFilterDtoDataTypeToJSON(value?: NumericTrackItDataTypeFilterDtoDataType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfNumericTrackItDataTypeDto(value)) {
        return NumericTrackItDataTypeDtoToJSON(value as NumericTrackItDataTypeDto);
    }

    return {};
}

/**
 * Check if a given object implements the NumericTrackItDataTypeFilterDtoDataType interface.
 */
export function instanceOfNumericTrackItDataTypeFilterDtoDataType(value: any): value is NumericTrackItDataTypeFilterDtoDataType {
    if (instanceOfNumericTrackItDataTypeDto(value)) return true;
    return false;
}

